<div *ngIf="dataLoading" class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf="!dataLoading">
  <mat-dialog-content class="preview confirm_access custom_height">
    <div class="mat-dialog-body">
      <div class="image-container text-center">
        <img src="./assets/images/illu_change_phone_number.svg" />
      </div>
      <h2 class="title">
        {{"appsConfiguration.securityVerificationRequired" | translate}}
      </h2>
      <p class="description">
        {{"appsConfiguration.enterMainAccountPassword" | translate}}
      </p>
      <form [formGroup]="formGroup">
        <input type="hidden" name="csrf_token" value="csrfToken" />
        <mat-form-field class="w-100 form-group mb-0" hideRequiredMarker>
          <mat-label>{{ 'forms.Password' | translate }}</mat-label>
          <input class="Passowrd" matInput formControlName="password" [type]="hidePassword ? 'password' : 'text'"
            maxlength="50">
          <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="hasError('password', 'required')">{{ 'forms.Required' | translate }}</mat-error>
          <mat-error *ngIf="hasError('password', 'notMatch')">{{ errorMsg }}</mat-error>
          <mat-error *ngIf="hasError('password', 'whitespace')">
            {{ "forms.Invalid value" | translate }}
          </mat-error>
        </mat-form-field>
        <div class="actions">
          <button (click)="confirmAccess()" mat-raised-button color="primary" [disabled]="loading"
            [class.loading]="loading">
            {{"appsConfiguration.confirmAccess" | translate}}
          </button>
          <button mat-button type="button" matDialogClose class="btn-grey">
            {{"forms.Cancel" | translate}}
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</ng-container>